export enum ESignInFields {
  email = 'email',
  password = 'password',
  companyCode = 'companyCode',
}

export type TSignInPayload = { email: string, password: string, companyCode?: string };
